import React from 'react'
import { Trans } from '@lingui/react'
import { useSelector } from 'react-redux'
import Layout from '../components/Layout'
import AppLinks from '../components/AppLinks'
import ErrorIcon from '../components/ErrorIcon'
import Header from '../components/Header'
import getPremiumAppName from '../selectors/customer/getPremiumAppName'

function NotAvailableScreen() {
  const customerPremiumAppName = useSelector(getPremiumAppName)

  return (
    <Layout>
      <div className="text-center flex-grow self-center space-y-8">
        <ErrorIcon />
        <Header className="text-orange-500"><Trans id="not-available.title">Niet beschikbaar</Trans></Header>
        <p className="font-bold text-lg">
          <Trans id="not-available.text">Hoy web is niet te gebruiken op je mobiel.</Trans>
        </p>
        <p className="font-bold text-lg">
          <Trans id="not-available.download" values={{ customerPremiumAppName: customerPremiumAppName || 'Hoy' }}>
            {'Download nu de {customerPremiumAppName} app om in te loggen.'}
          </Trans>
        </p>
        <AppLinks />
      </div>
    </Layout>
  )
}

export default NotAvailableScreen
